import { Paper } from '@mui/material';

import React from 'react';

import styles from './Banner.module.scss';

interface IBannerProps {
	children: React.ReactNode;
}
const Banner = (props: IBannerProps) => {
	const { children } = props;
	return <Paper className={styles['banner-styles']}>{children}</Paper>;
};

export default Banner;
